module.exports = __webpack_public_path__ + "images/arcade.76ae6f.jpg";